import React from "react";
import Training from "./Training";
import { useParams } from "react-router-dom";

export default function TrainingPreview() {
  const { trainingId, trainingVersion } = useParams();

  return (
    <Training
      preview={true}
      trainingId={trainingId || ""}
      trainingVersion={trainingVersion || ""}
    />
  );
}
